import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface MaintenanceSidebarMarkerProps {
  hasSoon: boolean;
  hasOverdue: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class MaintenanceSidebarMarkerService {
  readonly props$ = new BehaviorSubject<MaintenanceSidebarMarkerProps>({
    hasSoon: false,
    hasOverdue: false,
  });
}
